(ns frontend.ui.page.lp-portal.landing-page.promotions-section.style
  (:require
   [garden.units :refer [px]]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [color]]))

(defn section
  []
  ^{:media {{:screen :only :max-width :599px}
            {:gap     :0
             :padding "16px 16px 0"}}}
  {:display        :flex
   :flex-direction :column
   :gap            :24px
   :padding        "50px 16px"
   :position       :relative})

(defn promotions-topbar
  []
  {:display         :flex
   :justify-content :space-between
   :gap             :20px
   :position        :relative})

(defn carousel-card-wrapper
  []
  {:padding "16px"})

(defn next-nav-arrow
  []
  ^{:media {{:screen :only :max-width :1024px}
            {:top :100px}
            {:screen :only :max-width :700px}
            {:top       :50%
             :transform "translateY(-50%)"}
            {:screen :only :max-width :1400px}
            {:margin-right "0"
             :width        :35px
             :height       :35px}}}
  {:position         :absolute
   :top              :90px
   :right            :0
   :margin-right     "-25px"
   :background-color "rgba(255, 255, 255, 0.85)"
   :box-shadow       "0px 0px 4px 0px rgba(0, 0, 0, 0.31)"
   :width            :50px
   :height           :50px
   :border-radius    :50%
   :display          :flex
   :justify-content  :center
   :align-items      :center
   :color            "rgba(37, 62, 80, 1)"
   :z-index          :2
   :cursor           :pointer
  })

(defn prev-nav-arrow
  []
  ^{:media {{:screen :only :max-width :1024px}
            {:top :100px}
            {:screen :only :max-width :700px}
            {:top       :50%
             :transform "translateY(-50%)"}
            {:screen :only :max-width :1400px}
            {:margin-left "0 !important"
             :width       :35px
             :height      :35px}}}
  {:position         :absolute
   :top              :90px
   :margin-left      "-25px"
   :background-color "rgba(255, 255, 255, 0.85)"
   :box-shadow       "0px 0px 4px 0px rgba(0, 0, 0, 0.31)"
   :width            :50px
   :height           :50px
   :border-radius    :50%
   :display          :flex
   :justify-content  :center
   :align-items      :center
   :color            "rgba(37, 62, 80, 1)"
   :z-index          :2
   :cursor           :pointer
  })

(defn show-all
  []
  ^{:pseudo {:hover {:color (theme/color [:lp-portal :clickable :text :hover])}}
    :media  {{:screen :only :max-width :699px}
             {:position :static}
             {:screen :only :max-width :599px}
             {:font-weight    :700
              :font-size      :12px
              :gap            :8px
              :margin-right   :2px
              :user-select    :none
              :text-transform :uppercase}}}
  {:position    :absolute
   :display     :flex
   :gap         :10px
   :right       :55px
   :bottom      :50px
   :color       (theme/color [:lp-portal :clickable :text :default])
   :user-select :none
   :cursor      :pointer
   :align-self  :flex-end
   :white-space :nowrap})

(defn show-all-icon-desktop
  []
  ^{:media {{:screen :only :max-width :599px}
            {:display :none}}}
  {:display     :flex
   :padding-top :2px})

(defn show-all-icon-mobile
  []
  ^{:media {{:screen :only :max-width :599px}
            {:display :flex}}}
  {:display     :none
   :padding-top :2px})
